import React from 'react';

const DownArrowIcon = () => {
  return (
    <svg
      width='11'
      height='6'
      viewBox='0 0 11 6'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M9.9349 0.600006L5.26823 5.26667L0.601562 0.600006'
        stroke='#6B7280'
        strokeWidth='1.2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
};

export default DownArrowIcon;
